import { restaurantPropTypes } from '@nandosaus/prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import { Alert } from '../../alert';
import { Box, Flex } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const DeliveryEstimate = ({ handleChangeOrderType, estimate }) => {
  if (estimate === null) {
    return (
      <Alert type="error" onLinkClick={handleChangeOrderType} linkText="Change order type">
        Unfortunately your address is currently outside of our deliverable area.
      </Alert>
    );
  }

  return (
    <Box>
      <P variant="small-semi-bold" mb="12px">
        Delivery from
      </P>
      <Flex mb="8px" gap="8px" alignItems="center">
        <Icon name="barci" ml="-4px" height="30" />
        <P variant="small">{estimate.restaurant.name}</P>
      </Flex>
      <Flex alignItems="center" gap="8px">
        <Icon name="clock" height="20px" width="20px" />
        <P variant="small">Estimated delivery in {estimate.fromNow}</P>
      </Flex>
    </Box>
  );
};

DeliveryEstimate.propTypes = {
  estimate: PropTypes.shape({
    fromNow: PropTypes.string.isRequired,
    restaurant: restaurantPropTypes.isRequired,
  }),
  handleChangeOrderType: PropTypes.func.isRequired,
};

DeliveryEstimate.defaultProps = {
  estimate: null,
};

export { DeliveryEstimate };
